import { Variables, utils, type WorkspaceSvg } from 'blockly/core';

type FlyoutItemInfo = utils.toolbox.FlyoutItemInfo;
export const SKYROVER_VARIABLE_CATEGORY = 'SKYROVER_VARIABLES';

export const SKYROVER_CREATE_VARIABLE_KEY = 'SKYROVER_CREATE_VARIABLE';

let selectedVariableType = 'float';

export function getSelectedVariableCreatorType(): string {
  return selectedVariableType;
}

export function setSelectedVariableCreatorType(type: string): void {
  selectedVariableType = type;
}

export const SKYROVER_VARIABLE_TYPES = [
  { type: 'int', label: 'int' },
  { type: 'float', label: 'float' },
  { type: 'double', label: 'double' },
  { type: 'char', label: 'char' },
  { type: 'long', label: 'long' },
  { type: 'byte', label: 'byte' },
  { type: 'bool', label: 'bool' },
  { type: 'String', label: 'String' },
] as const;

export type SkyroverVariableType = (typeof SKYROVER_VARIABLE_TYPES)[number]['type'];

const NUMERIC_VARIABLE_TYPES = new Set<SkyroverVariableType>([
  'char',
  'int',
  'float',
  'double',
  'long',
  'byte',
]);

const SKYROVER_VARIABLE_TYPE_SET = new Set<string>(
  SKYROVER_VARIABLE_TYPES.map((entry) => entry.type),
);

export function getVariableCppType(blocklyType: string): string {
  if (SKYROVER_VARIABLE_TYPE_SET.has(blocklyType)) {
    return blocklyType;
  }

  switch (blocklyType) {
    case 'Boolean':
      return 'bool';
    case 'String':
      return 'String';
    case 'Number':
      return 'float';
    default:
      return 'float';
  }
}

export function isNumericVariableType(type: string): boolean {
  return NUMERIC_VARIABLE_TYPES.has(type as SkyroverVariableType);
}

export function registerSkyroverVariableToolbox(workspace: WorkspaceSvg): void {
  if (!workspace.getToolboxCategoryCallback(SKYROVER_VARIABLE_CATEGORY)) {
    workspace.registerToolboxCategoryCallback(
      SKYROVER_VARIABLE_CATEGORY,
      skyroverVariablesFlyoutCategory,
    );
  }

  if (!workspace.getButtonCallback(SKYROVER_CREATE_VARIABLE_KEY)) {
    workspace.registerButtonCallback(SKYROVER_CREATE_VARIABLE_KEY, () => {
      Variables.createVariableButtonHandler(
        workspace,
        undefined,
        getSelectedVariableCreatorType(),
      );
    });
  }
}

export function skyroverVariablesFlyoutCategory(workspace: WorkspaceSvg): FlyoutItemInfo[] {
  const flyoutContents: FlyoutItemInfo[] = [
    { kind: 'sep', id: undefined, gap: 52, cssconfig: undefined },
  ];

  const variables = workspace.getVariableMap().getAllVariables();
  if (variables.length > 0) {
    flyoutContents.push(
      ...Variables.jsonFlyoutCategoryBlocks(
        workspace,
        variables,
        false,
        'variables_get_dynamic',
        'variables_set_dynamic',
      ),
    );
  }

  return flyoutContents;
}
